'use client';

export const Mail = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="26"
			height="21"
			viewBox="0 0 26 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M2.14021 20.5263C1.55225 20.5263 1.04855 20.3166 0.629132 19.8972C0.20971 19.4778 0 18.9741 0 18.3861V2.14021C0 1.55225 0.20971 1.04855 0.629132 0.629132C1.04855 0.209711 1.55225 0 2.14021 0H23.8598C24.4478 0 24.9514 0.209711 25.3709 0.629132C25.7903 1.04855 26 1.55225 26 2.14021V18.3861C26 18.9741 25.7903 19.4778 25.3709 19.8972C24.9514 20.3166 24.4478 20.5263 23.8598 20.5263H2.14021ZM24.2806 3.2719L13.5867 10.2744C13.4909 10.3249 13.3963 10.3672 13.3028 10.4014C13.209 10.4356 13.1081 10.4527 13 10.4527C12.8919 10.4527 12.791 10.4356 12.6972 10.4014C12.6037 10.3672 12.5119 10.3249 12.4218 10.2744L1.71942 3.2719V18.3861C1.71942 18.5088 1.75888 18.6096 1.83779 18.6885C1.9167 18.7674 2.01751 18.8069 2.14021 18.8069H23.8598C23.9825 18.8069 24.0833 18.7674 24.1622 18.6885C24.2411 18.6096 24.2806 18.5088 24.2806 18.3861V3.2719ZM13 8.85779L24.0052 1.71942H2.01739L13 8.85779ZM1.71942 3.54558V2.3075V2.34411V1.71942V2.33247V2.28834V3.54558Z"
				fill="currentColor"
			/>
		</svg>
	);
};
